import React, { Component } from 'react';
import './Fields.css'
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
import * as routes from '../constants/routes';

class SettingsIndex extends Component {

  constructor(props) {
    super(props);

    this.state = {
      email: '',
    };
  }

  componentDidMount() {
    const { ucdUser, setCurrentPage } = this.props;
    if(ucdUser) {
      this.setState({
        email: ucdUser.email,
      });
    }
    setCurrentPage(routes.SETTINGS);
  }

  componentWillReceiveProps(props) {
    const { ucdUser } = props;
    if(ucdUser) {
      this.setState({
        email: ucdUser.email,
      });
    }
  }

  getMaskedEmail() {
    const { email } = this.state;
    const regExp = /[a-zA-Z0-9\-_.+]{3}@/;
    return email.replace(regExp, '***@');
  }

  render() {
    const { title } = this.props;
    return (
      <div className="col col-12 col-md-8">
        <div className="title">
          {title}
        </div>
        <form>
          <div className="field-container text">
            <div className="field-title">Email address</div>
            <div className="row">
              <div className="col">
                <p>{this.getMaskedEmail()}</p>
              </div>
              <div className="col text-right">
                <Link to="/settings/email">Edit email address</Link>
              </div>
            </div>
          </div>
          <div className="field-container text">
            <div className="field-title">Password:</div>
            <div className="row">
              <div className="col">
                <Link to="/settings/password">Edit password</Link>
              </div>
            </div>
          </div>
        </form>
        <form>
          <div className="field-container text">
            <div className="field-title">Delete Account</div>
            <div className="row">
              <div className="col">
                <p>I would like to delete my account</p>
              </div>
              <div className="col text-right">
                <Link to="/settings/delete-account">Delete my account</Link>
              </div>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  ...props,
  ucdUser: state.sessionState.ucdUser,
  authUser: state.sessionState.authUser,
});

const mapDispatchToProps = (dispatch) => ({
  onSetAuthUser: (authUser, ucdUser) => dispatch({ type: 'AUTH_USER_SET', authUser, ucdUser }),
  setCurrentPage: (page) => dispatch({ type: 'SET_CURRENT_PAGE', page }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsIndex);


// WEBPACK FOOTER //
// ./src/components/SettingsIndex.js